// Librerias
import React from 'react'
import { AutoSizer, Table, Column } from 'react-virtualized'
// Componentes
import Modal from 'react-bootstrap/lib/Modal.js'
// Style
import classNames from 'classnames/bind'
import * as cssModal from './modal.css'
let cx = classNames.bind(cssModal)

export class ModalTrigger extends React.Component{
    constructor(props){
        super(props)
        this.state = { visible: false }
        this.show  = ()=> this.setState({visible: true})
        this.hide  = ()=> this.setState({visible: false})
    }
    render(){
        return this.props.children(this.state.visible, this.show, this.hide)
    }
}

export class ModalEditarProduccion extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            idProduccion: this.props.idProduccion,
            error: {},
            produccion: this.props.produccion
        }
        this.onPrecioChange = (key, evt)=>{
            this.setState({produccion: evt.target.value})
        }
        this.handleSubmit = (evt)=>{
            evt.preventDefault()
            evt.stopPropagation()
            this.setState({error: {}}, ()=>{
                this.props.actualizarValor(this.state.idProduccion, this.state.produccion)
                    .then(()=>{
                        this.props.hideModal()
                    })
                    .catch(error=>{
                        this.setState({error: error.data})
                    })
            })
        }
    }
    componentWillMount(){
    }
    render(){
        return(
            <Modal show={true} onHide={this.props.hideModal} className={cx('modal')}>
                <Modal.Body>
                    <form className="form-horizontal" onSubmit={this.handleSubmit}>
                        <h4>Indíque el nuevo valor de la producción</h4>
                        <div className={cx('form-group', 'form__control-label')}>
                            <label className="col-sm-2 control-label">Valor Actual</label>
                            <div className="col-sm-3">
                                <input type="number" className="form-control" value={this.state.produccion}
                                       onChange={this.onPrecioChange.bind(this, 'valorZona')}
                                />
                            </div>
                        </div>

                        <div className={cx('editarUsuario_footer')}>
                            <a href="#" className={cx("btn btn-block btn-default", 'btn-50-perc')} onClick={this.props.hideModal}>Cancelar</a>
                            <button type="submit" className={cx("btn btn-block btn-primary", 'btn-50-perc')}>Modificar</button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./frontEnd/admin/mantenedorProducciones/Modales.jsx